/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () => ({
  personalStatement: chance.paragraph({ sentences: 3 }),
});
